import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OptionsService {
  public withText = false;
  public lefty = false;
  public doremi = false;
  constructor() { }
}
